import GhostContentAPI from '@tryghost/content-api';

const GHOST_API = new GhostContentAPI({
  url: 'https://quickscope.minervaarticles.com',
  // TODO put this in Vault
  key: 'a228244f18ada338f02ee77073',
  version: 'v3',
});

const LUCINA_URL = process.env.API_ENV
  ? process.env.API_ENV === `production`
    ? `https://api-lucina.com`
    : `https://internal.minerva.dev/staging/lucina-api`
  : `http://localhost:8080`;

const LUCINA_DOMAIN = 'thequickscope.com';

export { GHOST_API, LUCINA_URL, LUCINA_DOMAIN }
